import { Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import authgrd from "../Assets/AUTHGRD.png";
import otpillus from "../Assets/OTP.png";
import logo from "../Assets/logoNew.png";
const RegisterPopup = () => {
  const { userData } = useSelector((s) => s.auth);
  const [showPopup, setShowPopup] = useState(false);
  const [count, setCount] = useState(0);
  const location = useLocation();
  const noPopUpRoutes = ["/", "/tenders"];
  const navigate = useNavigate();
  useEffect(() => {
    if (userData) return;

    if (
      !sessionStorage.getItem("regpopshown") &&
      noPopUpRoutes.includes(location.pathname)
    ) {
      const timers = [];
      const schedulePopup = (timeInSeconds, c) => {
        const timerId = setTimeout(() => {
          setCount(c);
          setShowPopup(true);
        }, timeInSeconds * 1000);
        timers.push(timerId);
      };

      schedulePopup(8, 1);
      schedulePopup(40, 2);
      schedulePopup(60, 3);

      return () => timers.forEach(clearTimeout);
    }
  }, [location.pathname, userData]); // <== ADD DEPENDENCIES

  useEffect(() => {
    if (count === 3) {
      sessionStorage.setItem("regpopshown", true);
    }
  }, [count]);
  const handleClose = () => setShowPopup(false);

  return (
    <>
      {showPopup && (
        <Dialog
          id="registerPopUp"
          open={showPopup}
          onClose={handleClose}
          disableAutoFocus
          disableEnforceFocus
        >
          <div
            className="z-0 bg-white flex flex-col rounded-md justify-start items-start w-full p-4"
            style={{
              backgroundImage: `url(${authgrd})`, // Corrected syntax
              backgroundSize: "cover", // Ensures it covers the area
              backgroundRepeat: "no-repeat", // Prevents repeating
              backgroundPosition: "center",
              objectFit: "contain",
            }}
          >
            <div onClick={() => navigate("/")} className="cursor-pointer">
              <img src={logo} alt="pagelogo" className="h-[80px]" />
            </div>
            <div>
              <h1 className="text-4xl font-medium pl-4">
                Start your tender journey
              </h1>
            </div>
            <div className="z-10 flex flex-col justify-between items-start pl-4 mt-4 gap-4">
              <div className="text-green-500 flex justify-center items-center gap-2">
                <CheckCircleOutlineOutlinedIcon />
                <h1 className="text-[#212121] text-sm font-normal">
                  14 Days Free Trial for New User
                </h1>
              </div>
              <div className="text-green-500 flex justify-center items-center gap-2">
                <CheckCircleOutlineOutlinedIcon />
                <h1 className="text-[#212121] text-sm font-normal">
                  Get Right Tender, with Right Filters
                </h1>
              </div>
              <div className="text-green-500 flex justify-center items-center gap-2">
                <CheckCircleOutlineOutlinedIcon />
                <h1 className="text-[#212121] text-sm font-normal">
                  No Credit Card Required
                </h1>
              </div>
              <div className="text-green-500 flex justify-center items-center gap-2">
                <CheckCircleOutlineOutlinedIcon />
                <h1 className="text-[#212121] text-sm font-normal">
                  No Hidden Charges
                </h1>
              </div>
            </div>
            <div className="hidden md:relative top-[-150px] -z-10">
              <img src={otpillus} alt="OTPIllust" />
            </div>
            <div className="w-full p-4 flex justify-center items-center gap-8">
              <button
                onClick={() => {
                  sessionStorage.setItem("regpopshown", true);
                  handleClose();
                  navigate("/signup");
                }}
                className="flex justify-center items-center text-center gap-1 px-[6px] py-[6px] bg-[#0554F2] rounded-md text-white text-xs font-medium hover:bg-white hover:text-[#0554F2] border border-[#0554F2] transition-all duration-300 ease-in-out"
              >
                Register Now!!!
              </button>
              <button
                onClick={() => {
                  sessionStorage.setItem("regpopshown", true);
                  handleClose();
                  navigate("/login");
                }}
                className="flex justify-center items-center text-center gap-1 px-[6px] py-[6px] bg-[#0554F2] rounded-md text-white text-xs font-medium hover:bg-white hover:text-[#0554F2] border border-[#0554F2] transition-all duration-300 ease-in-out"
              >
                Log In
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default RegisterPopup;
